export default [
    { id: 'TemplateDetails', label: 'Template Details', parent: 'ExtractMaintenance' },
    { id: 'Fields', label: 'Fields', parent: 'ExtractMaintenance' },
];
